import { Attributes, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class InterestWithholdingTaxLookup extends ModelBase {
  
  public brokerAccountNumber: string = "";
  
  public eventDetail: string = "";

  public instrument: string = "";
  
  public eventID: string = "";

  @Attributes.Date()
  public eventDate: Date = new Date();

  public amountNC: number | null = null;

  public excluded: boolean | null = null;
}